import { DefaultError, useMutation, UseMutationOptions, useQuery } from "@tanstack/react-query";
import Certificado from "../../Models/Faturamento/Certificado";
import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { queryClient } from "../../App";
import RequestUtilitario, { BasicMutationAxiosType, BasicQueryType } from "../../Utils/RequisicaoUtilitario";
export function useAdicionar({
    onSuccess,
    queryKey,
    ...rest
}: BasicMutationAxiosType<
    { certificado: Certificado, arquivo: File },
    {},
    number
>) {
    return useMutation({
        ...rest,
        mutationFn: (data) => {            
            const formData = RequestUtilitario.objectToFormData(data.certificado);
            formData.append("arquivo", data.arquivo);

            const opcoes = {
                headers : {
                    "Content-Type" : "multipart/form-data"
                }
            };

            return Axios.post<number>("pessoa/certificado", formData, opcoes).then(t => t.data);
        },
        onSuccess : (...data) => {
            queryClient.invalidateQueries({
                queryKey: ["Pessoa.Certificado.Listar"]
            });
            onSuccess?.(...data);
        },
    });
}
export function useDasativar({
    onSuccess,
    queryKey,
    ...rest
}:BasicMutationAxiosType<
    number, 
    unknown,
    Promise<AxiosResponse<void, any>>
>) {
    return useMutation({
        ...rest,
        mutationFn : (data) => Axios.delete(`pessoa/certificado/${data}`),
        onSuccess : (...data) => {
            queryClient.invalidateQueries({
                queryKey: ["Pessoa.Certificado.Listar"]
            });
            onSuccess?.(...data);
        },
    });
}

export function useAtivar({
    onSuccess,
    queryKey,
    ...rest
}: BasicMutationAxiosType<
    number,
    unknown,
    Promise<AxiosResponse<void, any>>
>) {
    return useMutation({
        ...rest,
        mutationFn: (data) => Axios.patch(`pessoa/certificado/ativar/${data}`),
        onSuccess: (...data) => {
            queryClient.invalidateQueries({
                queryKey: ["Pessoa.Certificado.Listar"]
            });
            onSuccess?.(...data);
        },
    });
}

export function useListar({
    certificado,
    ativo,
    queryKey,
    ...reset
}: BasicQueryType<Certificado[], {
    certificado?: Certificado,
    ativo?: boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...certificado ?? {},
        codPessoa: certificado?.codPessoa ?? 0
    });

    return useQuery({
        ...reset,
        queryKey: ["Pessoa.Certificado.Listar", `Pessoa.Certificado.Listar?${queryString}`],
        queryFn: () => Axios.get<Certificado[]>(`pessoa/certificado?${queryString}`).then(t => {
            t.data.map(m => {
                m.dataVencimento = new Date(m.dataVencimento);
                return m;
            })
            return t.data;
        }),
        staleTime: 30 * 1000
    });
}

export function useBuscar({
    codigo,
    queryKey,
    ...rest
}: BasicQueryType<Certificado|null, {
    codigo:number
}>) {
    return useQuery({
        ...rest,
        queryKey: ["Pessoa.Certificado.Buscar", `Pessoa.Certificado.Buscar.${codigo}`],
        queryFn: () => Axios.get<Certificado|null>(`pessoa/certificado/${codigo}`).then(t => {
            if (t.data == null) return null;
            t.data.dataVencimento = new Date(t.data.dataVencimento);
            return t.data;
        }),
        staleTime: 30 * 1000
    });
}